import { createFileRoute } from '@tanstack/react-router'

import { QuizzesListPage } from '@/features/quizzes'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute('/_authenticated/_main/quizzes/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Quizzes') }]
  }),
  component: QuizzesListPage
})
